import { atomWithMutation } from 'jotai-tanstack-query';
import { quizService } from '../../services/quiz.service';
const quizSubmissionAtom = atomWithMutation(() => ({
    mutationKey: ['submissions'],
    mutationFn: async ({ code, data, }) => {
        await quizService.submitQuiz(code, data);
    },
}));
export { quizSubmissionAtom };
